import { PolylineEdge, PolylineEdgeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';

class AssociationView extends PolylineEdge {
  getEndArrow() { return h('g', {}); }
  getStartArrow() { return h('g', {}); }
}

class AssociationModel extends PolylineEdgeModel {
  initEdgeData(data) {
    super.initEdgeData(data);
    this.text = { ...this.text, value: '', editable: false };
  }

  getEdgeStyle() {
    const style = super.getEdgeStyle();
    const t = getThemeStyle(this.graphModel, 'association');
    style.stroke = t.stroke || '#8c8c8c';
    style.strokeWidth = t.strokeWidth || 1;
    style.strokeDasharray = '2,3';
    return style;
  }
}

export const Association = {
  type: 'dmn:Association',
  view: AssociationView,
  model: AssociationModel,
};
